// Helpers
import './helpers/lazy.js';

// Globals

document.addEventListener( 'DOMContentLoaded', function () {

  // Modal
  const modal = document.getElementById( 'modal' );
  if ( modal ) {
    const close = modal.querySelector( '.modal__close' );
    const backdrop = modal.querySelector( '.modal__backdrop' );

    const openModal = () => {
      modal.removeAttribute( 'hidden' );
      document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
      modal.setAttribute( 'hidden', '' );
      document.body.style.overflow = '';
    };

    document.querySelectorAll( '[data-open="modal"]' ).forEach( trigger => {
      trigger.addEventListener( 'click', e => {
        e.preventDefault();
        openModal();
      } );
    } );

    close.addEventListener( 'click', closeModal );
    backdrop.addEventListener( 'click', closeModal );

    document.addEventListener( 'keydown', e => {
      if ( e.key === 'Escape' && !modal.hasAttribute( 'hidden' ) ) closeModal();
    } );
  }



  const MobileMenuTrigger = document.getElementById( 'MobileMenuTrigger' );

  MobileMenuTrigger.addEventListener( 'click', function () {
    document.body.classList.toggle( 'mobile-menu-open' );
  } );

  const mobileMenu = document.getElementById( 'MobileMenu' );

  if ( mobileMenu ) {
    mobileMenu.querySelectorAll( 'li.menu-item-has-children' ).forEach( function ( menuItem ) {
      const subMenu = menuItem.querySelector( ':scope > .sub-menu' );
      if ( !subMenu ) return;

      const toggle = document.createElement( 'button' );
      toggle.type = 'button';
      toggle.className = 'submenu-toggle';
      toggle.setAttribute( 'aria-expanded', 'false' );
      toggle.setAttribute( 'aria-label', 'Rozwiń podmenu' );

      menuItem.insertBefore( toggle, subMenu );

      toggle.addEventListener( 'click', function () {
        const isOpen = subMenu.classList.toggle( 'active' );
        toggle.setAttribute( 'aria-expanded', String( isOpen ) );
      } );
    } );
  }

  // Subpage content — active points highlight
  const pointsNav = document.querySelector( '.subpage-content__points ol' );
  if ( pointsNav ) {
    const links = [ ...pointsNav.querySelectorAll( 'a[href^="#content-"]' ) ];
    const sections = links.map( a => document.querySelector( a.getAttribute( 'href' ) ) ).filter( Boolean );

    const setActive = id => {
      links.forEach( a => a.closest( 'li' ).classList.toggle( 'is-active', a.getAttribute( 'href' ) === '#' + id ) );
    };

    const observer = new IntersectionObserver( entries => {
      entries.forEach( entry => {
        if ( entry.isIntersecting ) setActive( entry.target.id );
      } );
    }, { rootMargin: '-15% 0px -75% 0px' } );

    sections.forEach( s => observer.observe( s ) );
  }

} );
